import React from 'react';
import { RichTextBlock } from './RichTextBlock';
import { SectionBlock } from './SectionBlock';
import { CardsBlock } from './CardsBlock';
import { HeroBlock } from './HeroBlock';
import { DividerBlock } from './DividerBlock';
import { CTABlock } from './CTABlock';
import { HTMLBlock } from './HTMLBlock';
import { LinksBlock } from './LinksBlock';
import { QuoteBlock } from './QuoteBlock';
import { FAQBlock } from './FAQBlock';
import { BookListBlock } from './BookListBlock';
export function ContentBlocks({ data }) {
    return React.createElement(React.Fragment, null, data.map((block) => React.createElement(ContentBlock, { key: block.id, data: block })));
}
// eslint-disable-next-line complexity
export function ContentBlock({ data }) {
    switch (data.type) {
        case 'hero':
            return React.createElement(HeroBlock, { data: data });
        case 'html':
            return React.createElement(HTMLBlock, { data: data });
        case 'cta_block':
            return React.createElement(CTABlock, { data: data });
        case 'divider':
            return React.createElement(DividerBlock, { data: data });
        case 'text':
            return React.createElement(RichTextBlock, { data: data });
        case 'section':
            return React.createElement(SectionBlock, { data: data });
        case 'cards_block':
            return React.createElement(CardsBlock, { data: data });
        case 'links_group':
            return React.createElement(LinksBlock, { data: data });
        case 'quote':
            return React.createElement(QuoteBlock, { data: data });
        case 'faq':
            return React.createElement(FAQBlock, { data: data });
        case 'book_list':
            return React.createElement(BookListBlock, { data: data });
        default:
            return React.createElement("pre", null, JSON.stringify(data, null, 2));
    }
}
